module.exports = __webpack_public_path__ + "static/media/english0.f705e62f.jpg";